import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "q-ma-sm" }, "Accéder directement au site :", -1 /* HOISTED */)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  id: "qr_code_legend",
  class: "q-mt-sm"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }

import { onBeforeMount, ref, computed } from 'vue';

// Personal components
import QPageTitle from 'src/view/components/QPageTitle.vue';

// Personal libs
import { apiGetBlobQrCode } from '@data/datasource/remote/ui.api';
import { EnvEnum } from '@shared/enum/env.enum';

/**
 * Reactive data
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

// Vendor
const qrCodeUrl = ref<string>('');
const msgErreur = ref<string | undefined>();

/**
 * Computed
 */
const env = computed<EnvEnum>(() => process.env.ENV);
const appUrl = computed<string>(
  () =>
    `${process.env.FRONTEND.host}${
      process.env.FRONTEND.port != '' ? ':' + process.env.FRONTEND.port : ''
    }`,
);

/**
 * Hooks
 */
onBeforeMount(async () => {
  const erreurTechnique =
    "Erreur technique lors de l'acquisition du QR Code de l'application";

  apiGetBlobQrCode()
    .then((response) => {
      if (response.status != null && response.status !== 200) {
        msgErreur.value = erreurTechnique;
      } else {
        const urlCreator = window.URL || window.webkitURL;
        qrCodeUrl.value = urlCreator.createObjectURL(response);
        msgErreur.value = undefined;
      }
    })
    .catch(() => (msgErreur.value = erreurTechnique));
});

return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(QPageTitle, { title: `Page d\'accueil` }),
    _hoisted_2,
    (msgErreur.value == null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_q_img, {
            src: qrCodeUrl.value,
            fit: "fill",
            height: '300px',
            width: '300px',
            "aria-labelledby": "qr_code_legend"
          }, null, 8 /* PROPS */, ["src"]),
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_4, "Contenu du QR Code : " + _toDisplayString(appUrl.value), 1 /* TEXT */)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(msgErreur.value), 1 /* TEXT */)),
    (env.value !== _unref(EnvEnum).PROD)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Environnement : " + _toDisplayString(env.value), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})